if (!customElements.get('media-gallery')) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          slider: this.querySelector('[id^="Slider-Thumbnails"]'),
          sliderMedia: this.querySelector('[id^="Slider-Gallery"]'),
          thumbnailsArray: this.querySelectorAll('[id^="Slide-Thumbnails"]'),
          parentContainer: this.closest("section") || this,
          sliderViewport: this.querySelector(
            '[id^="GalleryViewer"] .slider__viewport',
          ),
        };
        this.mql = window.matchMedia("(min-width: 750px)");

        /* MARCA | 04/13/2026 | Mobile thumbnail row - click to navigate and scroll sync */
        this.mobileThumbnailsRow = this.querySelector(".mobile-thumbnails-row");
        if (this.mobileThumbnailsRow) {
          this.mobileThumbnailsRow.addEventListener(
            "click",
            this.onMobileThumbnailClick.bind(this),
          );
          this.initMobileScrollSync();
        }

        if (!this.elements.thumbnails) return;
        this.elements.slider.addEventListener(
          "click",
          this.setActiveThumbnail.bind(this),
        );
        this.elements.slider.addEventListener("keyup", (event) => {
          if (event.code.toUpperCase() === "ENTER")
            this.setActiveThumbnail(event);
        });
        if (
          this.dataset.desktopLayout !== "one_column_grid" &&
          this.dataset.desktopLayout !== "two_columns_grid" &&
          this.mql.matches
        )
          this.removeListSemantic();
      }

      setActiveMedia(mediaId) {
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`,
        );
        if (
          this.elements.viewer.querySelectorAll(`.product__media-item--hide`)
            .length > 0 &&
          activeMedia
        ) {
          let activeMediaAlt = activeMedia.dataset.mediaAlt;
          this.elements.viewer
            .querySelectorAll(
              `.product__media-item:not(.product__media-item--full)`,
            )
            .forEach((media) => {
              media.classList.remove(
                "product__media-item--variant-alt",
                "product__media-item--show",
              );
              if (media.dataset.mediaAlt == activeMediaAlt)
                media.classList.add("product__media-item--variant-alt");
            });
        }
        if (!activeMedia) return;
        if (activeMedia) {
          if (
            this.elements.sliderMedia.classList.contains(
              "slider-main--original",
            ) &&
            !this.elements.sliderMedia.classList.contains("grid--peek")
          ) {
            let height = activeMedia.offsetHeight;
            if (this.elements.parentContainer.offsetWidth < 769) {
              this.elements.sliderMedia.closest(".product--side_thumbnails")
                ? this.elements.sliderMedia
                    .closest(".slider-block")
                    .removeAttribute("style")
                : this.elements.sliderMedia.removeAttribute("style");
              this.elements.sliderViewport.style.height = height + "px";
            } else {
              this.elements.sliderViewport.removeAttribute("style");
              this.elements.sliderMedia.closest(".product--side_thumbnails")
                ? (this.elements.sliderMedia.closest(
                    ".slider-block",
                  ).style.height = height + "px")
                : (this.elements.sliderMedia.style.height = height + "px");
            }
          }
          const prevActiv = this.elements.viewer.querySelector(`.is-active`);
          if (prevActiv) prevActiv.classList.remove("is-active");
          if (activeMedia) activeMedia.classList.add("is-active");
          this.elements.sliderMedia.scrollTo({
            left: activeMedia.offsetLeft,
            behavior: "smooth",
          });
        }
        if (this.querySelector('[id^="GalleryThumbnails"]')) {
          const prevActiveThumbnail =
            this.elements.thumbnails.querySelector(`.is-active`);
          if (prevActiveThumbnail)
            prevActiveThumbnail.classList.remove("is-active");
          let activeMediaAlt;
          let mediaIdValue;
          if (activeMedia) {
            activeMediaAlt = activeMedia.dataset.mediaAlt;
            mediaIdValue = activeMedia.dataset.mediaId;
          }
          const activeThumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${mediaIdValue}"]`,
          );
          if (activeThumbnail) activeThumbnail.classList.add("is-active");
          if (
            this.elements.viewer.querySelectorAll(`.product__media-item--hide`)
              .length > 0 &&
            activeMedia
          ) {
            this.elements.thumbnails
              .querySelectorAll(
                `.thumbnail-list__item:not(.product__media-item--full)`,
              )
              .forEach((thumbnail) => {
                thumbnail.classList.remove(
                  "product__media-item--variant-alt",
                  "product__media-item--show",
                );
                if (thumbnail.dataset.mediaAlt == activeMediaAlt)
                  thumbnail.classList.add("product__media-item--variant-alt");
              });
          }
          this.elements.slider.scrollTo({
            left: activeThumbnail.offsetLeft - activeThumbnail.offsetWidth - 8,
            behavior: "smooth",
          });
          if (
            activeThumbnail.parentElement.classList.contains(
              "thumbnail-list--column",
            )
          ) {
            this.elements.thumbnails.scrollTo({
              top: activeThumbnail.offsetTop - activeThumbnail.offsetHeight - 8,
              behavior: "smooth",
            });
          }
        }
        /* MARCA | 04/13/2026 | Sync mobile thumbnails on variant/media change */
        if (this.mobileThumbnailsRow && activeMedia) {
          this.mobileThumbnailsRow
            .querySelectorAll(".mobile-thumbnails-row__item")
            .forEach((item) => item.classList.remove("is-active"));
          const mobileThumb = this.mobileThumbnailsRow.querySelector(
            `[data-target="${activeMedia.dataset.mediaId}"]`,
          );
          if (mobileThumb) {
            mobileThumb.classList.add("is-active");
            mobileThumb.scrollIntoView({
              behavior: "smooth",
              inline: "center",
              block: "nearest",
            });
          }
        }
        if (!activeMedia) return;
        this.preventStickyHeader();
        window.setTimeout(() => {
          if (
            (this.dataset.desktopLayout === "one_column_grid" &&
              !activeMedia.classList.contains("product__media-item--hide")) ||
            (this.dataset.desktopLayout === "two_columns_grid" &&
              !activeMedia.classList.contains("product__media-item--hide"))
          ) {
            activeMedia.scrollIntoView({ behavior: "smooth" });
          }
        });
        this.playActiveMedia(activeMedia);
        if (!this.elements.thumbnails) return;
        this.announceLiveRegion(
          activeMedia,
          this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`)
            .dataset.mediaPosition,
        );
      }

      setActiveThumbnail(event) {
        let galleryMedia = this.elements.thumbnails
          .closest(".slider-block")
          .querySelector('[id^="GalleryViewer-"]');
        galleryMedia
          .querySelector('[id^="Slider-Gallery-"]')
          .classList.add("disable-scroll");
        if (!event.target.closest(".thumbnail-list__item")) return;
        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        this.elements.thumbnails
          .querySelectorAll("li")
          .forEach((item) => item.classList.remove("is-active"));
        galleryMedia
          .querySelectorAll("li")
          .forEach((item) => item.classList.remove("is-active"));
        let newActiveThumb = event.target.closest(".thumbnail-list__item");
        let activeThumbData = newActiveThumb.dataset.target;

        let newActiveMedia = this.elements.sliderMedia.querySelector(
          `[data-media-id="${activeThumbData}"]`,
        );
        setTimeout(() => {
          newActiveThumb.classList.add("is-active");
          newActiveThumb
            .querySelector("button")
            .setAttribute("aria-current", true);
          newActiveMedia.classList.add("is-active");
          if (
            this.elements.sliderMedia.classList.contains(
              "slider-main--original",
            ) &&
            !this.elements.sliderMedia.classList.contains("grid--peek")
          ) {
            let height = newActiveMedia.offsetHeight;
            if (this.elements.parentContainer.offsetWidth < 769) {
              this.elements.sliderMedia.closest(".product--side_thumbnails")
                ? this.elements.sliderMedia
                    .closest(".slider-block")
                    .removeAttribute("style")
                : this.elements.sliderMedia.removeAttribute("style");
              this.elements.sliderViewport.style.height = height + "px";
            } else {
              this.elements.sliderViewport.removeAttribute("style");
              this.elements.sliderMedia.closest(".product--side_thumbnails")
                ? (this.elements.sliderMedia.closest(
                    ".slider-block",
                  ).style.height = height + "px")
                : (this.elements.sliderMedia.style.height = height + "px");
            }
          }
          this.elements.sliderMedia.scrollTo({
            left: newActiveMedia.offsetLeft,
          });
          if (
            this.elements.slider.classList.contains("thumbnail-list--column")
          ) {
            this.elements.slider.closest(".thumbnail-slider--column").scrollTo({
              top: newActiveThumb.offsetTop - newActiveThumb.offsetHeight - 8,
              behavior: "smooth",
            });
          } else {
            this.elements.slider.scrollTo({
              left: newActiveThumb.offsetLeft - newActiveThumb.offsetWidth - 8,
              behavior: "smooth",
            });
          }
        }, 5);
        setTimeout(() => {
          galleryMedia
            .querySelector('[id^="Slider-Gallery-"]')
            .classList.remove("disable-scroll");
        }, 500);
      }

      /* MARCA | 04/13/2026 | Mobile thumbnail click handler - navigates main slider to selected media */
      onMobileThumbnailClick(event) {
        const thumbItem = event.target.closest(".mobile-thumbnails-row__item");
        if (!thumbItem) return;

        const mediaId = thumbItem.dataset.target;
        if (!mediaId) return;

        const activeMedia = this.elements.sliderMedia.querySelector(
          `[data-media-id="${mediaId}"]`,
        );
        if (!activeMedia) return;

        this.elements.sliderMedia.classList.add("disable-scroll");

        this.mobileThumbnailsRow
          .querySelectorAll(".mobile-thumbnails-row__item")
          .forEach((item) => item.classList.remove("is-active"));
        this.elements.sliderMedia
          .querySelectorAll(".is-active")
          .forEach((item) => item.classList.remove("is-active"));

        thumbItem.classList.add("is-active");
        activeMedia.classList.add("is-active");

        if (
          this.elements.sliderMedia.classList.contains(
            "slider-main--original",
          ) &&
          !this.elements.sliderMedia.classList.contains("grid--peek")
        ) {
          const height = activeMedia.offsetHeight;
          if (this.elements.parentContainer.offsetWidth < 769) {
            this.elements.sliderMedia.closest(".product--side_thumbnails")
              ? this.elements.sliderMedia
                  .closest(".slider-block")
                  .removeAttribute("style")
              : this.elements.sliderMedia.removeAttribute("style");
            this.elements.sliderViewport.style.height = height + "px";
          }
        }

        this.elements.sliderMedia.scrollTo({
          left: activeMedia.offsetLeft,
          behavior: "smooth",
        });

        const sliderComponent = this.elements.viewer;
        setTimeout(() => {
          this.elements.sliderMedia.classList.remove("disable-scroll");
          if (sliderComponent && typeof sliderComponent.update === "function") {
            sliderComponent.update();
            sliderComponent._scheduleDisableButtons?.();
          }
        }, 500);

        this.playActiveMedia(activeMedia);
      }

      /* MARCA | 04/13/2026 | Mobile thumbnail scroll sync - updates active thumbnail on main slider scroll */
      initMobileScrollSync() {
        if (!this.elements.sliderMedia) return;
        this.elements.sliderMedia.addEventListener(
          "scroll",
          () => {
            clearTimeout(this._mobileThumbScrollTimer);
            this._mobileThumbScrollTimer = setTimeout(() => {
              this.syncMobileThumbnails();
            }, 100);
          },
          { passive: true },
        );
      }

      syncMobileThumbnails() {
        if (!this.mobileThumbnailsRow) return;
        const activeSlide =
          this.elements.sliderMedia.querySelector(".is-active");
        if (!activeSlide) return;

        const activeMediaId = activeSlide.dataset.mediaId;
        if (!activeMediaId) return;

        this.mobileThumbnailsRow
          .querySelectorAll(".mobile-thumbnails-row__item")
          .forEach((item) => item.classList.remove("is-active"));
        const matchingThumb = this.mobileThumbnailsRow.querySelector(
          `[data-target="${activeMediaId}"]`,
        );
        if (matchingThumb) {
          matchingThumb.classList.add("is-active");
          matchingThumb.scrollIntoView({
            behavior: "smooth",
            inline: "center",
            block: "nearest",
          });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img",
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position,
            );
          if (image.closest(".lazy-image"))
            image.parentNode.classList.add("lazyloaded");
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation"),
        );
      }
    },
  );
}
